import { useQuery } from "@tanstack/react-query"
import { apiInstance } from "./api-instance"

export const useGetCertByNIK = (nik, querySetting = {}) => {
  return useQuery({
    queryKey: ["get_cert_by_nik", nik],
    queryFn: async () => {
      const response = await apiInstance.get(
        `/certificate/search-by-nik?nik=${nik}&APIkey=${process.env.NEXT_PUBLIC_API_KEY}`,
      )
      const cert = response?.data?.data
      return cert
    },
    enabled: !!nik,
    ...querySetting,
  })
}

export const useGetCertByNIKSubTrainingId = (
  nik,
  id_sub_training,
  querySetting = {},
) => {
  return useQuery({
    queryKey: ["get_cert_by_nik_sub_training_id", nik, id_sub_training],
    queryFn: async () => {
      const response = await apiInstance.get(
        `/certificate/get-cert-by-nik-id-sub?nik=${nik}&id_sub_training=${id_sub_training}&APIkey=${process.env.NEXT_PUBLIC_API_KEY}`,
      )
      const cert = response?.data?.data
      return cert
    },
    enabled: !!nik && !!id_sub_training,
    ...querySetting,
  })
}

export const useGetCertSubTraining = (nik, name, querySetting = {}) => {
  return useQuery({
    queryKey: ["get_cert_sub_training", nik, name],
    queryFn: async () => {
      const response = await apiInstance.get(
        `/certificate/select-sub-training?nik=${nik}&name=${name}&APIkey=${process.env.NEXT_PUBLIC_API_KEY}`,
      )
      const certSub = response?.data?.data
      return certSub
    },
    enabled: !!nik,
    ...querySetting,
  })
}

export const useGetTrackingByNIK = (nik, querySetting = {}) => {
  return useQuery({
    queryKey: ["get_tracking_by_nik", nik],
    queryFn: async () => {
      const response = await apiInstance.get(
        `/certificate/tracking-by-nik?nik=${nik}&APIkey=${process.env.NEXT_PUBLIC_API_KEY}`,
      )
      return response?.data?.data
    },
    enabled: !!nik && nik.length >= 16,
    ...querySetting,
  })
}

